import { render, staticRenderFns } from "./NotesComponent.vue?vue&type=template&id=122acfdc&scoped=true&"
import script from "./NotesComponent.vue?vue&type=script&lang=js&"
export * from "./NotesComponent.vue?vue&type=script&lang=js&"
import style0 from "./NotesComponent.vue?vue&type=style&index=0&id=122acfdc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122acfdc",
  null
  
)

export default component.exports